<template>
    <v-app-bar app flat>
        <v-app-bar-title class="text-no-wrap"><span class="text-no-wrap">{{title}}</span></v-app-bar-title>
        <v-spacer/>
        <Divisa/>
    </v-app-bar>
</template>
<script>
import Divisa from '@components/layout/components/divisa/local';

export default {
    components: {
        Divisa
    },
    computed: {
        title: function () {
            return this.$store.getters['ui/layout/getTitle'];
        },
    },
}
</script>